import type {
  TemplateCoverLetterTraditionalProps,
  TemplateCoverLetterTraditionalXinglet,
} from '@xing-com/crate-lebenslauf-xinglets';

import { CoverLetterTraditional } from './cover-letter-traditional';

export default class TemplateCoverLetterTraditional
  implements TemplateCoverLetterTraditionalXinglet
{
  public getComponent() {
    return (props: TemplateCoverLetterTraditionalProps): JSX.Element => (
      <CoverLetterTraditional {...props} />
    );
  }
}
